// extracted by mini-css-extract-plugin
export default {"search":"Home_search__Vlqzw","input":"Home_input__6qLsz","mrInput":"Home_mrInput__ibIXi","results":"Home_results__ypPNX","page":"Home_page__OUVS-","cards":"Home_cards__FRr8F"};